import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AlertComponent } from '../../common/alert/alert.component';
import { PlatformComponent } from '../../models/workflow/Model.model';
import { WorkflowService } from '../../services/workflow-service';
import { GlobalService } from '../../services/global.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-scenario-specification',
  templateUrl: './formula-specification.component.html',
  styleUrls: ['../flowsheet-specification/flowsheet-specification.component.css']
})
export class FormulaSpecificationComponent implements OnInit {
  componentDetails: PlatformComponent = new PlatformComponent();
  isLoading= false;
  readOnly: boolean = false;
  modelErrorMessage;
  formulaListDetails;
  selectedFormula = [];
  dropdownSettings: IDropdownSettings = {};

  constructor(public dialogRef: MatDialogRef<FormulaSpecificationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public workflowService: WorkflowService,
    public dialog: MatDialog,
    public globals: GlobalService
    ) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.getFormulaList();
    this.componentDetails = this.data.component;
    if (this.data.component.formulaList.length > 0) {
      this.selectedFormula = this.data.component.formulaList;
    }
    this.readOnly = this.data.readOnly;
  }

  getFormulaList() {
    this.workflowService.getFormulaList().subscribe((data: any): void => {
      if (data.length > 0) {
        this.formulaListDetails = data;
        this.dropdownSettings = {
          singleSelection: false,
          idField: 'name',
          textField: 'name',
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          maxHeight: 180,
          itemsShowLimit: 2,
          allowSearchFilter: true
        };
      } else {
        this.globals.showAlert(AlertComponent, { success: false, message: "Formula's list not availalble!" });
      }
      this.isLoading = false;
    }, (error: Error) => {
      this.globals.showAlert(AlertComponent, { success: false, message: "Error in fetching formula list!" });
      this.isLoading = false;
    });
  }

  saveFormulaListDetails() {
    this.data.component.componentDetails.id = 1;
    this.data.component.formulaList = this.selectedFormula;
    this.dialogRef.close(false);
  }

  onCancelClick() {
    this.dialogRef.close(false);
  }

}
